import { z } from 'zod'
import locationMessages from '../../../Locations/messages'
import messages from '../messages'

const geofenceSchema = z.object({
  lat: z.number(),
  lng: z.number(),
})

const addressSchema = z.object({
  id: z.number().optional(),
  countryId: z.number().min(1, locationMessages.countryValidation.defaultMessage),
  address1: z.string().min(1, locationMessages.address1Validation.defaultMessage),
  city: z.string().min(1, locationMessages.cityValidation.defaultMessage),
  state: z.string().min(1, locationMessages.stateValidation.defaultMessage),
  postalCode: z.string().min(1, locationMessages.postCodeValidation.defaultMessage),
  address2: z.string().optional(),
})

export const customerSchema = z.object({
  id: z.number().optional(),
  name: z
    .string()
    .min(1, messages.customerNameRequired.defaultMessage)
    .max(250, 'Name must be maximum 250 characters'),
  alias: z.string().max(250, 'Alias must be maximum 250 characters').optional(),
  accountNumber: z.string().max(50, 'Account Number must be maximum 50 characters').optional(),
  registrationNumber: z
    .string()
    .max(50, 'Company Registration Number must be maximum 50 characters')
    .optional(),
  vatNumber: z.string().max(50, 'VAT Number must be maximum 50 characters').optional(),
  webSite: z.string().max(50, 'Website must be maximum 50 characters').optional(),
  address: addressSchema,
  defaultCurrencyId: z
    .union([z.number().min(1, messages.defaultCurrencyIsRequired.defaultMessage), z.undefined()])
    .refine((val) => val !== undefined && val > 0, {
      message: messages.defaultCurrencyIsRequired.defaultMessage,
    }),
  defaultTransportModeId: z.number().nullable().optional(),
  email: z
    .string()
    .max(250, 'Email must be maximum 250 characters')
    .optional()
    .nullable()
    .refine((email) => {
      if (!email || email === '' || email === null || email === undefined) return true
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      return emailRegex.test(email)
    }, 'Invalid email address format'),
  secondaryEmail: z
    .string()
    .max(250, 'Secondary Email must be maximum 250 characters')
    .optional()
    .nullable()
    .refine((email) => {
      if (!email || email === '' || email === null || email === undefined) return true
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      return emailRegex.test(email)
    }, 'Invalid email address format'),
  accountOwnerId: z
    .union([z.number().min(1, messages.accountOwnerIsRequired.defaultMessage), z.undefined()])
    .refine((val) => val !== undefined && val > 0, {
      message: messages.accountOwnerIsRequired.defaultMessage,
    }),
  industryId: z.number().optional(),
  tenantId: z.number().optional(),
  locationId: z.number().optional(),
  locationName: z.string().optional(),
  addressId: z.number().optional(),
  lat: z.number().optional(),
  lng: z.number().optional(),
  geofence: z.array(geofenceSchema).optional(),
  contacts: z.array(z.any()).optional(),
  documents: z.array(z.any()).optional(),
  disabled: z.boolean().optional(),
  validFrom: z.union([z.date(), z.string()]).nullable().optional(),
  validTo: z.union([z.date(), z.string()]).nullable().optional(),
})

export type CustomerFormData = z.infer<typeof customerSchema>
